// extracted by mini-css-extract-plugin
export default {"card-header":"BrandAccount_card-header__xLaI6","account-row":"BrandAccount_account-row__FGpQa","button-width":"BrandAccount_button-width__+jVDb"};